import React, { useState, useEffect } from "react";

function NextSVG() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
      <path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z" />
    </svg>
  );
}

function PrevSVG() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
      <path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z" />
    </svg>
  );
}

function getHrefLink(pageNumber) {
  if (typeof window === "undefined" || pageNumber < 1) return "#";

  const url = new URL(window.location.href);
  url.searchParams.delete("page");
  if (url.searchParams.get("category") === "all") {
    url.searchParams.delete("category");
  }

  const base = url.pathname.replace(/\/page\/\d+\/?$/, "/");
  const path = base.endsWith("/") ? base : `${base}/`;
  url.pathname = pageNumber > 1 ? `${path}page/${pageNumber}/` : path;

  return url.pathname + url.search + url.hash;
}

function Paginate({ totalPages, currentPage, handlePrevious, handleNext }) {
  return (
    <div className="Paginate u-viewed">
      <div className="Paginate-innerMob">
        <div
          className="Paginate-mobile"
          style={totalPages == 1 ? { display: "none" } : {}}
        >
          {currentPage > 1 ? (
            <a
              href={getHrefLink(currentPage - 1)}
              dataset-page={currentPage - 1}
              className="prev"
              onClick={handlePrevious}
            >
              <PrevSVG />
            </a>
          ) : (
            <span className="prev u-disabled">
              <PrevSVG />
            </span>
          )}

          <div className="Paginate-pageDesktop">
            <span className="current">{`${currentPage}`}</span>
            <span className="delimiter"> of </span>
            <span className="max-page">{`${totalPages}`}</span>
          </div>

          {currentPage < totalPages ? (
            <a
              href={getHrefLink(currentPage + 1)}
              className="next"
              dataset-page={currentPage + 1}
              onClick={handleNext}
            >
              <NextSVG />
            </a>
          ) : (
            <span className="next u-disabled">
              <NextSVG />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default function GCPages({ totalPages, currentPage, update }) {
  const filterDefined = window.location.href.indexOf("category=") > -1;
  const gridCards = document.getElementById("GridCards");
  const [page, setPage] = useState(1);
  let allTerms = [-1];

  useEffect(() => {
    setPage(currentPage);
  }, [currentPage]);

  function handlePrevious(e) {
    e.preventDefault();
    if (page > 1) {
      setPage((page) => page - 1);
      updateLinks(page - 1);
    }
  }

  function handleNext(e) {
    e.preventDefault();
    if (page < totalPages) {
      setPage((page) => page + 1);
      updateLinks(page + 1);
    }
  }

  function updateLinks(page) {
    gridCards.scrollIntoView({ behavior: "smooth" });
    const filteredTerm = filterDefined
      ? window.location.href.split("category=")[1].split("&")[0]
      : "all";

    const categoryTerm = document.querySelector(
      `#categoriesFilter li[data-slug=${filteredTerm}]`
    );

    allTerms = [categoryTerm.dataset.termId];

    window.history.pushState(null, null, getHrefLink(page));
    update && update({ terms: allTerms, page_num: page });
  }

  return (
    <Paginate
      totalPages={totalPages}
      currentPage={page}
      handlePrevious={handlePrevious}
      handleNext={handleNext}
    />
  );
}
